import React, { useState, useEffect } from 'react';
import Fingerprint2 from 'fingerprintjs2';
import { getLikeCountByBlogId, hasUserLiked, createLike, removeLike } from '../../services/likeService';
// Analytics disabled
import './blogStyles.css';

const LikeButton = ({ blogId }) => {
  const [likeCount, setLikeCount] = useState(0);
  const [isLiked, setIsLiked] = useState(false);
  const [loading, setLoading] = useState(true);
  const [userFingerprint, setUserFingerprint] = useState(null);

  useEffect(() => {
    const initFingerprint = async () => {
      try {
        const components = await Fingerprint2.getPromise();
        const values = components.map(component => component.value);
        const fingerprint = Fingerprint2.x64hash128(values.join(''), 31);
        setUserFingerprint(fingerprint);
      } catch (error) {
        console.error('Error generating fingerprint:', error);
      }
    };
    initFingerprint();
  }, []);

  useEffect(() => {
    const fetchLikeData = async () => {
      if (!userFingerprint) return;
      try {
        const count = await getLikeCountByBlogId(blogId);
        setLikeCount(count);
        const liked = await hasUserLiked(blogId, userFingerprint);
        setIsLiked(liked);
      } catch (error) {
        console.error('Error fetching like data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchLikeData();
  }, [blogId, userFingerprint]);

  const handleLike = async () => {
    if (!userFingerprint) return;
    try {
      if (isLiked) {
        await removeLike(blogId, userFingerprint);
        setLikeCount(prev => prev - 1);
        setIsLiked(false);
      } else {
        await createLike({ blogId, userFingerprint });
        setLikeCount(prev => prev + 1);
        setIsLiked(true);
      }
    } catch (error) {
      console.error('Error toggling like:', error);
    }
  };

  if (loading) return <button disabled>Loading...</button>;

  return (
    <button onClick={handleLike} className={`like-button ${isLiked ? 'liked' : ''}`}>
      {isLiked ? 'Unlike' : 'Like'} ({likeCount})
    </button>
  );
};

export default LikeButton;